import axios from '../../utils/axios';

export const getIdThunk = async (_, thunkApi) => {
  try {
    const res = await axios.get('/id');
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const getTextThunk = async (payload, thunkApi) => {
  try {
    const { textId } = payload;
    const res = await axios.get('/text', {
      params: {
        textId,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const mintNftThunk = async (payload, thunkApi) => {
  try {
    const {
      nextId,
      textId,
      chainId,
      address,
      account,
      textColor,
      backgroundColor,
    } = payload;
    const res = await axios.post('/nft', {
      nftId: nextId,
      textId,
      chainId,
      contract: address,
      owner: account,
      textColor,
      backgroundColor,
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const cacheNftThunk = async (payload, thunkApi) => {
  try {
    const { _nftId, chainId, contract } = payload;
    const res = await axios.put('/nft', {
      _nftId,
      chainId,
      contract,
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};
